import React from "react";
import { useBluelagoon } from "@bluelagoon";
import { useAuth } from "../context/AuthContext";
import { Button } from "@shadcn-in-nx/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { BADGE_CONFIG, BADGE_KEYS } from "./badgeConfig";

export default function BlueprintBadgeToggle({ blueprint, onBadgeUpdated }) {
    const { isSuperAdmin, isSupport } = useAuth();
    const { call: updateBadges, isLoading } = useBluelagoon({ method: "updateBlueprintBadges" });

    if (!isSuperAdmin && !isSupport) return null;

    const currentBadges = blueprint?.badges || [];

    const handleToggle = async (badge) => {
        const result = await updateBadges({ blueprintId: blueprint.id, badge });
        if (result?.status === 200) {
            toast.success(result.message);
            onBadgeUpdated?.(result.data.badges);
        } else {
            toast.error(result?.message || "Failed to update badge");
        }
    };

    return (
        <div className="border rounded-lg p-3 bg-gray-50">
            <p className="text-xs font-medium text-gray-500 mb-2">Manage Verification Badges</p>
            <div className="flex flex-wrap gap-2">
                {BADGE_KEYS.map((key) => {
                    const { label, icon: Icon, className } = BADGE_CONFIG[key];
                    const active = currentBadges.includes(key);
                    return (
                        <Button
                            key={key}
                            size="sm"
                            variant={active ? "default" : "outline"}
                            disabled={isLoading}
                            className={active ? className : ""}
                            onClick={(e) => { e.stopPropagation(); handleToggle(key); }}
                        >
                            {isLoading ? <Loader2 className="h-3 w-3 mr-1 animate-spin" /> : <Icon className="h-3 w-3 mr-1" />}
                            {label}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
}
